import {gsap} from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin)

class HomeBanner {
	static instance = null;

	static create(el) {
		if (HomeBanner.instance === null) {
			if (el) {
				HomeBanner.instance = new HomeBanner(el);
			}
		}
	}

	static destroy() {
		if (HomeBanner.instance) {
			HomeBanner.instance.beforeDestroy();
			HomeBanner.instance = null;
		}
	}

	constructor(el) {
		this.el = el;
		this.init();
	}

	init() {
		this.bannerSlideIn = this.el.querySelectorAll('[data-home-slideIn]');
		this.initFirstTransitionAnimation();
	}

	initFirstTransitionAnimation() {
		const arrayOfImage = gsap.utils.toArray(this.bannerSlideIn);
		const banner1 = document.querySelectorAll('.banner-text span')
		const banner2 = document.querySelectorAll('.banner-text-bottom span')

		window.scroller.stop(),
			gsap.set(arrayOfImage, {alpha: 0, y: window.screen.height});
		this.animationHomeBanner = gsap.timeline({
			delay: 0.5,
			onComplete: () => {
				this.bannerSlideIn.forEach((el) => {
					el.parentNode.style.willChange = 'auto';
				});
			}
		}).from(banner1, {duration: 1.2, y: 75, autoAlpha: 0, stagger: 0.15, ease: "circ.out", clearProps: true})
			.to(arrayOfImage,
				{
					duration: 0.9,
					alpha: 1,
					y: 0,
					stagger: 0.2,
					rotationZ: 0.01,
					force3D: true,
					ease: "circ.out",
					clearProps: true,
					lazy: false,
					overwrite: "auto",
					immediateRender: false,
				}, '-=1')
			.from(banner2, {
				duration: 1, y: 200, alpha: 0, stagger: 0.15, ease: "circ.out", clearProps: true,
			}, '-=1')

		setTimeout(() => {
			window.scroller.start()
		}, this.animationHomeBanner.totalDuration() * 1000);
	}

	beforeDestroy() {
		this.el = null;
		this.animationHomeBanner.kill();
	}
}

export default HomeBanner;
